import { Link } from "react-router-dom";
import { ArrowRight, Check, Minus, ShieldCheck, Truck } from "lucide-react";
import PageShell, { Section } from "@/components/site/PageShell";
import { Cards, Note, Prose } from "@/components/site/ui";
import { ICONS } from "@/components/site/icons";
import {
  CUSTOM, CUSTOM_FAQ, PLATFORMS, PROCESS, QUOTE_FACTORS, READY, READY_CONSOLES, SERVICES, WARRANTY_MONTHS,
} from "@/content/custom";

export default function Custom() {
  return (
    <PageShell eyebrow={CUSTOM.eyebrow} title={CUSTOM.title} lead={CUSTOM.lead}
      actions={<>
        <a href="mailto:custom@performcustom.com?subject=Demande%20Custom" className="button button-dark" data-testid="custom-contact">Décrire mon besoin<ArrowRight size={13} /></a>
        <Link to="/tarifs" className="button button-outline">Tarifs du coaching</Link>
      </>}>

      <Section><Note kind="info">{CUSTOM.notice}</Note></Section>

      <Section title="Ce qui fait varier le prix" lead="Cinq éléments déterminent un devis. Les voici, pour que le chiffre annoncé n'ait rien d'arbitraire.">
        <Cards items={QUOTE_FACTORS} cols={2} />
      </Section>

      <Section title="Plateformes prises en charge">
        <div className="card-grid cols-2">
          <div className="info-card">
            <h3>Consoles</h3>
            <div className="pill-row" style={{ marginTop: 12 }}>
              {PLATFORMS.consoles.map(p => <span key={p} className="pill">{p}</span>)}
            </div>
          </div>
          <div className="info-card">
            <h3>Manettes</h3>
            <div className="pill-row" style={{ marginTop: 12 }}>
              {PLATFORMS.manettes.map(p => <span key={p} className="pill">{p}</span>)}
            </div>
          </div>
        </div>
      </Section>

      {SERVICES.map(s => {
        const Icon = ICONS[s.icon];
        return (
          <Section key={s.key} id={s.key} title={s.title} lead={s.lead}>
            <div className="custom-list">
              {s.items.map(item => (
                <div key={item.label} className={`custom-item${item.highlight ? " is-highlight" : ""}`} data-testid={`custom-${s.key}`}>
                  <span className="custom-icon">{Icon && <Icon size={14} />}</span>
                  <div>
                    <strong>{item.label}</strong>
                    {item.note && <small>{item.note}</small>}
                  </div>
                  <span className="custom-quote">Sur devis</span>
                </div>
              ))}
            </div>
          </Section>
        );
      })}

      <Section title="Consoles prêtes à brancher" lead="Console comprise, ou reprise de la vôtre.">
        <div className="card-grid cols-2">
          {READY_CONSOLES.map(r => (
            <div key={r.name} className="plan">
              <h3>{r.name}</h3>
              <div className="plan-quote">Sur devis<small>{r.name.startsWith("Console") ? "console comprise" : "sur votre console"}</small></div>
              <p className="plan-text">{r.text}</p>
              <ul>{r.includes.map(i => <li key={i}><Check size={13} />{i}</li>)}</ul>
              <a href={`mailto:custom@performcustom.com?subject=${encodeURIComponent(r.name)}`} className="button button-outline">
                Demander un devis<ArrowRight size={13} />
              </a>
            </div>
          ))}
        </div>
      </Section>

      <Section title="Manettes prêtes à jouer" lead="Manette comprise, déjà configurée, testée avant envoi.">
        <div className="card-grid">
          {READY.map(r => (
            <div key={r.name} className={`plan${r.highlight ? " is-highlight" : ""}`}>
              <h3>{r.name}</h3>
              <div className="plan-quote">Sur devis<small>manette comprise</small></div>
              <p className="plan-text">{r.text}</p>
              <ul>{r.includes.map(i => <li key={i}><Check size={13} />{i}</li>)}</ul>
              <a href={`mailto:custom@performcustom.com?subject=${encodeURIComponent(r.name)}`} className={`button ${r.highlight ? "button-dark" : "button-outline"}`} data-testid={`custom-ready-${r.name.split(" ")[1].toLowerCase()}`}>
                Demander un devis<ArrowRight size={13} />
              </a>
            </div>
          ))}
        </div>
      </Section>

      <Section title="Comment ça se passe"><Cards items={PROCESS} /></Section>

      <Section title="Délais et garantie">
        <div className="card-grid cols-2">
          <div className="info-card">
            <span className="feature-icon"><Truck size={15} /></span>
            <h3>Délais</h3>
            <p>Cinq à dix jours ouvrés en atelier, hors transport. Une option express en 48 heures existe ; son supplément figure au devis.</p>
          </div>
          <div className="info-card">
            <span className="feature-icon"><ShieldCheck size={15} /></span>
            <h3>Garantie</h3>
            <p>{WARRANTY_MONTHS} mois sur les pièces posées et le travail réalisé. L'ouverture de la coque met fin à la garantie constructeur : c'est vrai partout, nous la remplaçons par la nôtre.</p>
          </div>
        </div>
      </Section>

      <Section title="Questions fréquentes">
        <div className="faq-list" style={{ maxWidth: 720 }}>
          {CUSTOM_FAQ.map(f => (
            <details key={f.q}><summary><span>{f.q}</span><Minus size={14} /></summary><p>{f.a}</p></details>
          ))}
        </div>
      </Section>

      <Section>
        <Prose>
          <p>
            Abonné au coaching ? La cotisation donne <strong>10 % de remise</strong> sur
            tout devis Custom, tant qu'elle est active. <Link to="/cotisation">Voir les paliers</Link>.
          </p>
        </Prose>
      </Section>
    </PageShell>
  );
}
